import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GOOGLE_MAPS_API_VERSION } from '../../constants/business.constants';

import { HomePluginRoutingModule } from './home-plugin-routing.module';
import { HomePluginComponent } from './home-plugin.component';
import { WidgetsModule } from '../../widgets/widgets.module';
import { TemplateModule } from '../../components/template/template.module';
import { NoteDialogModule } from '../../components/note-dialog/note-dialog.module';
import { NoteAttachmentBufferModule } from '../../components/note-attachment-buffer/note-attachment-buffer.module';
import { NoteAttachmentsModule } from '../../components/note-attachments/note-attachment.module';
import { ContactDialogModule } from '../../components/contact-dialog/contact-dialog.module';
import { EntityDialogModule } from '../../components/entity-dialog/entity-dialog.module';
import { EntityDialogComponent } from '../../components/entity-dialog/entity-dialog.component';
import { CalendarDialogModule } from '../../components/calendar-dialog/calendar-dialog.module';
import { WebTemplateViewModel } from '../../components/template/template-web.view-model';
import { DynamicComponentService } from '../../services/dynamic-component.service';
import { ContactDialogComponent } from '../../components/contact-dialog/contact-dialog.component';
import { EffectsModule } from '@ngrx/effects';
import { ContactEffects } from '@tamalelibs/redux/contact.effects';
import { EntryTemplateWebEffects } from '../../redux/effects/template-web.effects';
import { EntityTypeEffects } from '../../redux/effects/entity-type.effects';
import { EntryTypeEffects } from '../../redux/effects/entry-type.effects';
import { NoteOptionEffects } from '@tamalelibs/redux/note.effects';
import { RelationshipTypeEffects } from '../../redux/effects/relationship-type.effects';
import { SystemEffects } from '../../redux/effects/system.effects';
import { TeamsEffects } from '../../redux/effects/teams.effects';
import { UsersEffects } from '../../redux/effects/users.effects';
import { EntityWebEffects } from '../../redux/effects/entity.effects';
import { TemplateFieldsEffects } from '../../redux/effects/template-field.effects';
import { globalServices_plugin } from '../../services/service.index';
import { DuplicateContactDialogModule } from '../../components/duplicated-contact-dialog/duplicated-contact-dialog.module';
import { AgmCoreModule, LAZY_MAPS_API_CONFIG } from 'ng-agm-core-lib';
import { SignatureEffects } from '../../redux/effects/signature.effects';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { HttpErrorInterceptor } from '../../services/http-interceptors.service';
import { AppLoadService } from '../../app-load.service';

@NgModule({
    imports: [
        CommonModule,
        // Feature modules
        WidgetsModule,
        TemplateModule,
        ContactDialogModule,
        EntityDialogModule,
        NoteDialogModule,
        CalendarDialogModule,
        TemplateModule,
        NoteAttachmentsModule,
        NoteAttachmentBufferModule,
        DuplicateContactDialogModule,
        // Routing module
        HomePluginRoutingModule,
        AgmCoreModule.forRoot({
            libraries: ['places'],
            apiVersion: GOOGLE_MAPS_API_VERSION
        }),
        EffectsModule.forFeature([
            ContactEffects,
            EntryTemplateWebEffects,
            EntityTypeEffects,
            EntryTypeEffects,
            NoteOptionEffects,
            RelationshipTypeEffects,
            SystemEffects,
            TeamsEffects,
            UsersEffects,
            EntityWebEffects,
            TemplateFieldsEffects,
            SignatureEffects,
        ]),
    ],
    declarations: [
        HomePluginComponent,
    ],
    providers: [
        WebTemplateViewModel,
        DynamicComponentService,
        {
            provide: HTTP_INTERCEPTORS,
            useClass: HttpErrorInterceptor,
            multi: true
        },
        {
            provide: LAZY_MAPS_API_CONFIG,
            useFactory: (appLoadService: AppLoadService) => ({
                apiKey: appLoadService.getAgmApiKey,
                libraries: ['places'],
                apiVersion: GOOGLE_MAPS_API_VERSION
            }),
            deps: [AppLoadService]
        },
        ...globalServices_plugin
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class HomePluginModule { }
